class TabList extends HTMLElement {
    constructor() {
        super();
        this.activators = this.querySelectorAll('[data-activator]');
        this.tabs = this.querySelectorAll('[data-tab]');
    }

    updateActivator(action, activator) {
        if (!action || !activator) return
        if (action === 'activate') {
            activator.classList.remove('bg-white', 'text-grey-5C');
            activator.classList.add('bg-supergoop-yellow', 'text-grey-2A')
        } else {
            activator.classList.add('bg-white', 'text-grey-5C');
            activator.classList.remove('bg-supergoop-yellow', 'text-grey-2A')
        }
    }

    updateActivators(currentIndex) {
        [...this.activators].forEach((a) => {
            if (a.dataset.activator === currentIndex) {
                this.updateActivator('activate', a)
            } else {
                this.updateActivator('deactivate', a)
            }
        })
    }

    updateTabs(currentIndex) {
        [...this.tabs].forEach((t) => {
            if (t.dataset.tab === currentIndex) {
                t.classList.replace('hidden', 'block');
            } else {
                t.classList.replace('block', 'hidden');
            }
        })
    }

    onTabListClick(e) {
        if (!e.target.dataset.activator) return
        const index = e.target.dataset.activator;
        this.updateActivators(index);
        this.updateTabs(index)
    }

    bindListeners() {
        this.addEventListener('click', this.onTabListClick.bind(this));
    }

    connectedCallback() {
        this.bindListeners();
    }
}

if (!customElements.get('tab-list')) {
    customElements.define('tab-list', TabList);
}